<script>
    import _ from 'lodash';

    export default {
        name: 'LodashPlugin',
        install: function (Vue, name = '_') {
            Object.defineProperty(Vue.prototype, name, {value: _});
        }
    }
</script>